/**
 * Created by mukund on 2/18/16.
 */

'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('lmsCourse', {
                parent: 'site',
                url: '/lms/course/:collectionId/:authToken/:isLTI',
                params: {
                    authToken: null,
                    isLTI: '1',
                    destinationFolderId: null,
                    destinationFolderCollectionTree: null,
                    showUnpublished: false
                },
                data: {
                    roles: [],
                    pageTitle: 'course.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/collection/templates/collection.html',
                        controller: 'CollectionController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        return $translate.refresh();
                    }]
                }
            });
    });
